import React from 'react';
import {
    Box,
    Grid,
    Typography,
    LinearProgress,
} from '@mui/material';
import type { StatistikaOdpovedi } from '../api/JsdhNotifikaceService/generated/models/OsobniStatistika';

interface PeriodStatsViewProps {
    stats: StatistikaOdpovedi;
    showProgressBar?: boolean;
}

const PeriodStatsView: React.FC<PeriodStatsViewProps> = ({ stats, showProgressBar = true }) => (
    <Grid container spacing={2}>
        <Grid size={{ xs: 6, sm: 3 }}>
            <Box textAlign="center">
                <Typography variant="h4" color="success.main" fontWeight="bold">
                    {stats.pocetJedu}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    JEDU
                </Typography>
            </Box>
        </Grid>
        <Grid size={{ xs: 6, sm: 3 }}>
            <Box textAlign="center">
                <Typography variant="h4" color="error.main" fontWeight="bold">
                    {stats.pocetNejedu}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    NEJEDU
                </Typography>
            </Box>
        </Grid>
        <Grid size={{ xs: 6, sm: 3 }}>
            <Box textAlign="center">
                <Typography variant="h4" color="primary.main" fontWeight="bold">
                    {stats.celkemPoplachu}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Poplachů
                </Typography>
            </Box>
        </Grid>
        <Grid size={{ xs: 6, sm: 3 }}>
            <Box textAlign="center">
                <Typography variant="h4" color="info.main" fontWeight="bold">
                    {stats.procentoUcasti !== null ? `${stats.procentoUcasti.toFixed(0)}%` : '-'}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Účast
                </Typography>
            </Box>
        </Grid>
        {showProgressBar && stats.celkemOdpovedi > 0 && (
            <Grid size={{ xs: 12 }}>
                <Box sx={{ mt: 1 }}>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        Poměr JEDU / NEJEDU
                    </Typography>
                    <LinearProgress
                        variant="determinate"
                        value={stats.procentoJedu ?? 0}
                        sx={{
                            height: 10,
                            borderRadius: 5,
                            bgcolor: 'error.light',
                            '& .MuiLinearProgress-bar': {
                                bgcolor: 'success.main',
                            },
                        }}
                    />
                    <Box display="flex" justifyContent="space-between" mt={0.5}>
                        <Typography variant="caption" color="success.main">
                            {stats.procentoJedu !== null ? `${stats.procentoJedu.toFixed(0)}%` : '-'}
                        </Typography>
                        <Typography variant="caption" color="error.main">
                            {stats.procentoJedu !== null ? `${(100 - stats.procentoJedu).toFixed(0)}%` : '-'}
                        </Typography>
                    </Box>
                </Box>
            </Grid>
        )}
    </Grid>
);

export default PeriodStatsView;
